import React from 'react';
import SectionTitle from '../Common/SectionTitle';

const ContactInfo = (props) => {
    const { contactBoxClass } = props;
    return (
        <div className={contactBoxClass ? contactBoxClass : 'contact-box'}>
            <SectionTitle
                sectionClass="sec-title mb-44"
                subtitleClass="sub-text new-text white-color"
                // subtitle="Let's Talk with Us!"
                titleClass="title white-color"
                title="Let's Talk With Us!"
            />
            <div className="address-box mb-24">
                <div className="address-icon">
                    <i className="fa fa-phone"></i>
                </div>
                <div className="address-text">
                    <span className="label">Phone:</span>
                    <a href="tel:9654652847">(+91) 9654652847</a>
                </div>
            </div>
            <div className="address-box mb-24">
                <div className="address-icon">
                    <i className="fa fa-home"></i>
                </div>
                <div className="address-text">
                    <span className="label">Email:</span>
                    <a href="https://mail.google.com/mail/?view=cm&fs=1&to=info@techniajz.com" target="_blank" rel="noopener noreferrer">info@techniajz.com</a>
                </div>
            </div>
            <div className="address-box">
                <div className="address-icon">
                    <i className="fa fa-map-marker"></i>
                </div>
                <div className="address-text">
                    <span className="label">Address:</span>
                    <div className="desc">1st Floor, 92/62, Patel Marg, Ward 27, <br/> Sector 9, Mansarovar, Jaipur, Rajasthan 302021</div>
                </div>
            </div>
        </div>
    );

}

export default ContactInfo;